export default "__VITE_ASSET__B$LBvfBF__ 100w, __VITE_ASSET__CKteZ_ZK__ 200w, __VITE_ASSET__EWJiAG3o__ 300w";